import { Container, Stack } from "@mui/material";
import { Page } from "../../../components";
import HeaderBreadcrumbs from "../../../components/header-breadcrumbs";
import { NewMessageComposeComponent } from "../../../components/message-center/v2/send-a-message/new-message-compose-component";
import { useParams } from "react-router-dom";

export const EditMessageComposeScreen = () => {
    const { id } = useParams();
    
    return (
        <Page title="POM Safe - Edit Message">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs 
                        heading="Edit message"
                        links={[
                            { name: 'Message Center', href: '/messages' },
                            { name: 'Edit Recipients', href: `/messages/${id}/edit/recipients` },
                            { name: 'Edit Message', href: `/messages/${id}/edit/compose` },
                        ]}
                        activeLast={false}
                    />
                </Stack>

                <NewMessageComposeComponent />
            </Container>
        </Page>
    )
}